var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKcelllogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 16,
    viewBox: "0 0 48 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5196 8.78418C28.5196 8.55578 28.6958 6.35465 31.0326 6.35465C32.5817 6.35465 33.1411 7.26488 33.4346 8.78418H28.5196ZM31.1157 3.99111C27.6358 3.99111 25.4963 6.73194 25.4963 10.0159C25.4963 12.8531 27.0634 16 31.1157 16C34.793 16 35.8383 13.5519 36.2639 12.1831H34.3462C33.9042 12.1831 33.583 12.3642 33.2829 12.7482C33.1574 12.8971 32.5149 13.6601 31.2234 13.6601C28.6077 13.6601 28.5702 11.5064 28.5196 10.7704H36.4563C36.6797 7.46452 34.9952 3.99111 31.1157 3.99111Z",
    fill: "#652D86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3283 0.00508154V12.8481C38.3512 15.012 38.7344 15.7631 41.3321 15.7631L41.3304 2.53781C41.3092 0.409438 40.9114 0.00508154 38.3283 0.00508154Z",
    fill: "#652D86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1597 0.00508154V12.8481C44.1826 15.012 44.5674 15.7631 47.1635 15.7631L47.1602 2.53781C47.1406 0.409438 46.7444 0.00508154 44.1597 0.00508154Z",
    fill: "#652D86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1909 11.344C22.1909 11.344 21.5027 11.3186 21.2385 12.0698C20.8635 13.139 20.1769 13.6601 19.0077 13.6601C17.1895 13.6601 16.4981 11.8634 16.4981 10.0175C16.4981 8.26477 17.2091 6.35465 19.073 6.35465C20.2356 6.35465 20.8521 6.89436 21.1162 7.59479C21.2597 7.97546 21.4733 8.32061 22.1403 8.32061H24.2651C24.1037 5.37337 21.6609 3.99111 19.0909 3.99111C15.3044 3.99111 13.478 6.84022 13.478 10.1529C13.478 13.8615 15.9583 16 19.0273 16C21.7114 16 23.9047 14.6025 24.3255 11.344H22.1909Z",
    fill: "#652D86"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0523987 15.7631H3.37904V10.6892L5.29186 8.67759C5.29186 8.67759 7.13945 11.525 8.38042 13.4656C9.62628 15.4011 10.2231 15.7631 12.4474 15.7631H14.0602L7.55202 6.22777L13.4845 0.00507561H11.8587C10.2851 0.00507561 9.2659 0.0642911 8.01514 1.43809C6.75786 2.80681 3.37904 6.53907 3.37904 6.53907V3.06905C3.37416 0.783335 2.99746 0 0.0523987 0V15.7631Z",
    fill: "#652D86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcelllogo);
export default __webpack_public_path__ + "static/media/Kcell.logo.d4447039eed09d6232c4e8d608e7eb0a.svg";
export { ForwardRef as ReactComponent };